import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import * as moment from 'moment';
import { RenewalWindowComponent } from 'src/app/renewal-window/renewal-window.component';
import { MatDialog } from '@angular/material';
import { IndividualDashboardComponent } from '../individual-dashboard.component';
import { ReportComponent } from 'src/app/reports/report.component';
import { AlertReportComponent } from 'src/app/reports/alert/alert-report.component';
import { RealTimeGraphsComponent } from '../real-time-graphs/real-time-graphs.component';
import { LiveTableComponent } from '../live-table/live-table.component';
import { AiModelComponent } from '../ai-model/ai-model.component';
var DigitaltwinComponent = /** @class */ (function () {
    function DigitaltwinComponent(route, _dashboardService, router, matDialog, globalService) {
        this.route = route;
        this._dashboardService = _dashboardService;
        this.router = router;
        this.matDialog = matDialog;
        this.globalService = globalService;
        this.signalStrength = 0;
        this.bars = [1, 2, 3, 4, 5];
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.selectedTransformer = null;
        this.showInfo = 'first';
        this.windTemperature = 0;
        this.oilTemperature = 0;
        this.alertsData = [];
        this.blinkState = false;
        this.kWh = 0;
        this.kvArh = 0;
        this.avgPF = 0;
        this.kVAh = 0;
        this.voltage_l1 = 0;
        this.voltage_l2 = 0;
        this.voltage_l3 = 0;
        this.current_l1 = 0;
        this.current_l2 = 0;
        this.current_l3 = 0;
        this.activePower = 0;
        this.Lug_Temp_R = 0.00;
        this.Lug_Temp_Y = 0.00;
        this.Lug_Temp_B = 0.00;
        this.lastUpdateDate = '';
        this.voltageparameter = false;
        this.currentparameter = false;
        this.dataforHealthIndex = "";
        this.AIRequestData = '';
        this.isChatOpen = false;
        this.userMessage = '';
        this.messages = [];
        this.typingDelay = 1000;
        this.isTyping = false;
        this.batteryStatusImgUrl = "../../../assets/images/fullbattery.png";
        this.graphs_3d = [
            {
                data: [
                    {
                        type: "indicator",
                        mode: "gauge+number",
                        value: 65,
                        title: { text: "Health Index", font: { color: "white", size: 16 } },
                        gauge: {
                            axis: { range: [null, 100], tickcolor: "white" },
                            bar: { color: "#f39c89" },
                            steps: [
                                { range: [0, 20], color: "#33cc33" },
                                { range: [20, 40], color: "#ffcc00" },
                                { range: [40, 60], color: "#ff3300" },
                                { range: [60, 80], color: "#ff3300" },
                                { range: [80, 100], color: "#ff3300" },
                            ],
                            bordercolor: "white",
                            borderwidth: 2
                        },
                        number: { font: { color: "white" } }
                    }
                ],
                layout: {
                    autosize: true,
                    width: 230,
                    height: 250,
                    plot_bgcolor: "transparent",
                    paper_bgcolor: "transparent",
                    margin: { t: 30, b: 30, l: 30, r: 30 },
                    font: { color: "white" }
                }
            },
            {
                data: [
                    {
                        type: "indicator",
                        mode: "gauge",
                        value: 20,
                        title: { text: "Oil Level", font: { color: "white", size: 16 } },
                        gauge: {
                            axis: { range: [null, 100], tickcolor: "white" },
                            bar: { color: "#f39c89" },
                            steps: [
                                { range: [0, 20], color: "#33cc33" },
                                { range: [20, 40], color: "#ffcc00" },
                                { range: [40, 60], color: "#ff9933" },
                                { range: [60, 80], color: "#ff3300" },
                                { range: [80, 100], color: "#ff0000" } // Deep red for critical values
                            ],
                            bordercolor: "white",
                            borderwidth: 2
                        }
                    }
                ],
                layout: {
                    autosize: true,
                    width: 184,
                    height: 175,
                    plot_bgcolor: "transparent",
                    paper_bgcolor: "transparent",
                    margin: { t: 30, b: 30, l: 30, r: 30 },
                    font: { color: "white" },
                    annotations: [
                        {
                            text: function () {
                                // Dynamically set the label based on the value
                                var value = 20; // Replace this with the dynamic value
                                if (value <= 20)
                                    return "Low";
                                if (value > 20 && value <= 60)
                                    return "Mid";
                                return "High";
                            }(),
                            font: { color: "white", size: 18 },
                            showarrow: false,
                            align: "center",
                            x: 0.5,
                            y: 0.5 // Center position
                        }
                    ]
                }
            },
            {
                data: [
                    { x: ['A', 'B', 'C'], y: [30, 50, 70], type: 'bar', marker: { color: '#e74c3c' } }
                ],
                layout: {
                    title: { text: 'Ambient Temperature', font: { color: 'white' } },
                    autosize: true,
                    width: 184,
                    height: 175,
                    plot_bgcolor: 'transparent',
                    paper_bgcolor: 'transparent',
                    margin: { t: 30, b: 30, l: 30, r: 30 },
                    bordercolor: 'white',
                    borderwidth: 1,
                    xaxis: { title: { font: { color: 'white' } }, showgrid: false, },
                    yaxis: { title: { font: { color: 'white' } }, showgrid: false, },
                    font: { color: 'white' },
                }
            },
            {
                data: [
                    {
                        type: "indicator",
                        mode: "gauge+number",
                        value: 75,
                        title: { text: "Winding Temperature", font: { color: "white", size: 16 } },
                        gauge: {
                            axis: { range: [null, 100], tickcolor: "white" },
                            bar: { color: "#f39c89" },
                            steps: [
                                { range: [0, 20], color: "#33cc33" },
                                { range: [20, 40], color: "#ffcc00" },
                                { range: [40, 60], color: "#ff3300" },
                                { range: [60, 80], color: "#ff3300" },
                                { range: [80, 100], color: "#ff3300" },
                            ],
                            bordercolor: "white",
                            borderwidth: 2
                        },
                        number: { font: { color: "white" } }
                    }
                ],
                layout: {
                    autosize: true,
                    width: 230,
                    height: 250,
                    plot_bgcolor: "transparent",
                    paper_bgcolor: "transparent",
                    margin: { t: 30, b: 30, l: 30, r: 30 },
                    font: { color: "white" }
                }
            }
        ];
        this.transformerList = [];
        this.plotlyConfig = {
            displaylogo: false,
            modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d'],
            responsive: true
        };
        this.networkFlag = false;
        this.lugTempFlag = false;
        this.isTwoMeter = false;
    }
    DigitaltwinComponent.prototype.ngAfterViewChecked = function () {
        this.scrollToBottom();
    };
    DigitaltwinComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payloadtogetTransformer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payloadtogetTransformer = {
                            "countryid": null,
                            "stateid": null,
                            "cityid": null,
                            "zoneid": null,
                            "locationid": null,
                            "transformerid": null,
                        };
                        return [4 /*yield*/, this.getTranformerId(JSON.stringify(payloadtogetTransformer))];
                    case 1:
                        _a.sent();
                        this.oilLevel(0);
                        this.TapoilLevel(0);
                        this.loadGraph();
                        this.healthIndexData();
                        return [2 /*return*/];
                }
            });
        });
    };
    DigitaltwinComponent.prototype.connectToWebSocket = function () {
        var _this = this;
        console.log("Connected to Socket");
        this.socket = new WebSocket('wss://api.trafobola.com');
        this.socket.onopen = function () {
            console.log('✅ WebSocket connected');
        };
        this.socket.onerror = function (event) {
            console.error('❌ WebSocket Error:', event);
        };
        this.socket.onmessage = function (event) {
            var webSocketData = JSON.parse(event.data);
            if (webSocketData.topic == "LV_1") {
                _this.alertsData = [];
                var mqttData = JSON.parse(event.data);
                console.log("recieved", mqttData);
                mqttData = JSON.parse(mqttData.data);
                mqttData.Oil_Temperature = Number(mqttData.Oil_Temperature / 10).toFixed(2);
                mqttData.Winding_Temperature = Number(mqttData.Winding_Temperature / 10).toFixed(2);
                mqttData.latestDATE = mqttData.Date.replace(/'/g, "");
                console.log("Parsed Data:", mqttData);
                _this.transformerData = mqttData;
                _this.jsonReadings = mqttData;
                _this.meterData(mqttData);
                _this.updateData();
                if (_this.parameterConfig.lugtempr == 1) {
                    _this.Lug_Temp_R = _this.jsonReadings.Lug_Temp_R.toFixed(2);
                    _this.Lug_Temp_Y = _this.jsonReadings.Lug_Temp_Y.toFixed(2);
                    _this.Lug_Temp_B = _this.jsonReadings.Lug_Temp_B.toFixed(2);
                }
                var avgCurrent = (Number(mqttData.L1) + Number(mqttData.L2) + Number(mqttData.L3)) / 3;
                var currentDeviation = Math.max(Math.abs(Number(mqttData.L1) - avgCurrent), Math.abs(Number(mqttData.L2) - avgCurrent), Math.abs(Number(mqttData.L3) - avgCurrent));
                var iUnbalance = Number((currentDeviation * 100) / avgCurrent).toFixed(2);
                console.log("what is iUnbalance", iUnbalance);
                var avgVoltage = (Number(mqttData.RY_Voltage) + Number(mqttData.YB_Voltage) + Number(mqttData.BR_Voltage)) / 3;
                var voltageDeviation = Math.max(Math.abs(Number(mqttData.RY_Voltage) - avgVoltage), Math.abs(Number(mqttData.YB_Voltage) - avgVoltage), Math.abs(Number(mqttData.BR_Voltage) - avgVoltage));
                var vUnbalance = ((voltageDeviation * 100) / avgVoltage).toFixed(2);
                if (mqttData.Oil_Temperature > 50) {
                    _this.alertsData.push({ "parametername": "Oil Temperature", "gparametervalue": mqttData.Oil_Temperature });
                }
                if (mqttData.Oil_Level == 4) {
                    _this.alertsData.push({ "parametername": "Oil Level", "gparametervalue": "Low" });
                }
                if (_this.load > 80) {
                    _this.alertsData.push({ "parametername": "Overload", "gparametervalue": _this.load.toFixed(2) });
                }
                if (_this.load < 20) {
                    _this.alertsData.push({ "parametername": "Underload", "gparametervalue": _this.load.toFixed(2) });
                }
                if (mqttData.Average_Voltage > 250) {
                    _this.alertsData.push({ "parametername": "High Voltage", "gparametervalue": mqttData.Average_Voltage.toFixed(2) });
                }
                if (mqttData.Average_Voltage < 180) {
                    _this.alertsData.push({ "parametername": "Low Voltage", "gparametervalue": mqttData.Average_Voltage.toFixed(2) });
                }
                if (mqttData.Winding_Temperature > 50) {
                    _this.alertsData.push({ "parametername": "Winding Temperature", "gparametervalue": mqttData.Winding_Temperature.toFixed(2) });
                }
                if (vUnbalance > 10) {
                    _this.alertsData.push({ "parametername": "Voltage Unbalance", "gparametervalue": vUnbalance.toFixed(2) });
                }
                if (iUnbalance > 15) {
                    _this.alertsData.push({ "parametername": "Current Unbalance", "gparametervalue": iUnbalance.toFixed(2) });
                }
                if (mqttData.Avg_Power_Factor < 0.9) {
                    _this.alertsData.push({ "parametername": "Low Power Factor", "gparametervalue": mqttData.Avg_Power_Factor.toFixed(2) });
                }
                var harmonics = 0;
                if (mqttData.hasOwnProperty('VB_THD')) {
                    harmonics = (((mqttData.VB_THD + mqttData.VR_THD + mqttData.VY_THD) / 3) * 100).toFixed(2);
                }
                // Variables declaration
                var oilLevel = 0;
                var oilTemp = 0;
                var windingTemp = 0;
                var pf = 0;
                var humidity = 0;
                var loadValue = 0;
                var harmonicsvalue = 0;
                var age = 0;
                var iUnbalanceValue = 0;
                var vUnbalanceValue = 0;
                var repaired = 0;
                // Oil Level Conditions
                if (mqttData.Oil_Level == 4) {
                    oilLevel = 0;
                }
                else if (mqttData.Oil_Level == 5) {
                    oilLevel = 100;
                }
                else if (mqttData.Oil_Level == 6) {
                    oilLevel = 0;
                }
                // Oil Temperature Conditions
                if (mqttData.Oil_Temperature <= 40) {
                    oilTemp = 100;
                }
                else if (mqttData.Oil_Temperature >= 41 && mqttData.Oil_Temperature <= 45) {
                    oilTemp = 80;
                }
                else if (mqttData.Oil_Temperature >= 46 && mqttData.Oil_Temperature <= 50) {
                    oilTemp = 60;
                }
                else if (mqttData.Oil_Temperature >= 51 && mqttData.Oil_Temperature <= 55) {
                    oilTemp = 40;
                }
                else if (mqttData.Oil_Temperature > 55) {
                    oilTemp = 20;
                }
                // Winding Temperature Conditions
                if (mqttData.Winding_Temperature <= 45) {
                    windingTemp = 100;
                }
                else if (mqttData.Winding_Temperature >= 45 && mqttData.Winding_Temperature <= 50) {
                    windingTemp = 80;
                }
                else if (mqttData.Winding_Temperature >= 51 && mqttData.Winding_Temperature <= 55) {
                    windingTemp = 60;
                }
                else if (mqttData.Winding_Temperature >= 55 && mqttData.Winding_Temperature <= 60) {
                    windingTemp = 40;
                }
                else if (mqttData.Winding_Temperature > 60) {
                    windingTemp = 20;
                }
                // Power Factor Conditions
                if (Number(mqttData.Avg_Power_Factor) >= 0.9) {
                    pf = 100;
                }
                else if (Number(mqttData.Avg_Power_Factor) < 0.9 && Number(mqttData.Avg_Power_Factor) >= 0.8) {
                    pf = 90;
                }
                else if (Number(mqttData.Avg_Power_Factor) < 0.8 && Number(mqttData.Avg_Power_Factor) >= 0.7) {
                    pf = 80;
                }
                else if (Number(mqttData.Avg_Power_Factor) < 0.8 && Number(mqttData.Avg_Power_Factor) >= 0.6) {
                    pf = 70;
                }
                // Humidity Conditions
                if (mqttData.Humidity <= 20) {
                    humidity = 100;
                }
                else if (mqttData.Humidity > 20 && mqttData.Humidity <= 40) {
                    humidity = 80;
                }
                else if (mqttData.Humidity > 40 && mqttData.Humidity <= 60) {
                    humidity = 70;
                }
                else if (mqttData.Humidity > 60 && mqttData.Humidity <= 80) {
                    humidity = 60;
                }
                // Load Conditions
                if (_this.load < 90) {
                    loadValue = 100;
                }
                else if (_this.load >= 91 && _this.load <= 100) {
                    loadValue = 90;
                }
                else if (_this.load >= 101 && _this.load <= 110) {
                    loadValue = 80;
                }
                else if (_this.load >= 111 && _this.load <= 120) {
                    loadValue = 70;
                }
                else if (_this.load >= 121 && _this.load <= 130) {
                    loadValue = 60;
                }
                else if (_this.load > 130) {
                    loadValue = 50;
                }
                // Harmonics Conditions
                if (harmonics < 0.1) {
                    harmonicsvalue = 100;
                }
                else if (harmonics > 0.1 && harmonics <= 1) {
                    harmonicsvalue = 90;
                }
                else if (harmonics > 1 && harmonics <= 2) {
                    harmonicsvalue = 80;
                }
                // Age Conditions
                if (10 < 5) {
                    age = 100;
                }
                else if (10 > 5 && 10 <= 10) {
                    age = 80;
                }
                else if (10 > 10 && 10 <= 15) {
                    age = 60;
                }
                else if (10 > 15 && 10 <= 20) {
                    age = 40;
                }
                else if (10 > 20) {
                    age = 20;
                }
                // Current Unbalance Conditions
                if (iUnbalance <= 10) {
                    iUnbalanceValue = 100;
                }
                else if (iUnbalance > 10 && iUnbalance >= 20) {
                    iUnbalanceValue = 90;
                }
                else if (iUnbalance > 21 && iUnbalance >= 25) {
                    iUnbalanceValue = 80;
                }
                else if (iUnbalance > 25 && iUnbalance >= 30) {
                    iUnbalanceValue = 70;
                }
                else if (iUnbalance > 30 && iUnbalance >= 35) {
                    iUnbalanceValue = 60;
                }
                else if (iUnbalance > 35 && iUnbalance >= 40) {
                    iUnbalanceValue = 50;
                }
                else if (iUnbalance > 40 && iUnbalance >= 45) {
                    iUnbalanceValue = 40;
                }
                else if (iUnbalance > 45 && iUnbalance >= 50) {
                    iUnbalanceValue = 30;
                }
                else if (iUnbalance > 50) {
                    iUnbalanceValue = 20;
                }
                // Voltage Unbalance Conditions
                if (vUnbalance <= 10) {
                    vUnbalanceValue = 100;
                }
                else if (vUnbalance > 10 && vUnbalance >= 20) {
                    vUnbalanceValue = 90;
                }
                else if (vUnbalance > 21 && vUnbalance >= 25) {
                    vUnbalanceValue = 80;
                }
                else if (vUnbalance > 25 && vUnbalance >= 30) {
                    vUnbalanceValue = 70;
                }
                else if (vUnbalance > 30 && vUnbalance >= 35) {
                    vUnbalanceValue = 60;
                }
                else if (vUnbalance > 35 && vUnbalance >= 40) {
                    vUnbalanceValue = 50;
                }
                else if (vUnbalance > 40 && vUnbalance >= 45) {
                    vUnbalanceValue = 40;
                }
                else if (vUnbalance > 45 && vUnbalance >= 50) {
                    vUnbalanceValue = 30;
                }
                else if (vUnbalance > 50) {
                    vUnbalanceValue = 20;
                }
                repaired = 100;
                // Health Index Calculation
                var healtIndexPercentage = (((oilLevel * 15) / 100) +
                    ((oilTemp * 20) / 100) +
                    ((windingTemp * 20) / 100) +
                    ((pf * 10) / 100) +
                    ((humidity * 5) / 100) +
                    ((loadValue * 10) / 100) +
                    ((harmonicsvalue * 0) / 100) +
                    ((age * 5) / 100) +
                    ((iUnbalanceValue * 5) / 100) +
                    ((vUnbalanceValue * 5) / 100) +
                    ((repaired * 5) / 100)).toFixed(2);
                console.log("asasdasasasdasd", healtIndexPercentage);
                // Handling NaN cases
                if (healtIndexPercentage == 'NaN') {
                    healtIndexPercentage = 0;
                }
                // Logging the Health Index Information
                var logString = "\n      oilLevel: 15 - " + (oilLevel * 15 / 100).toFixed(2) + "\n      oilTemp: 20  -  " + (oilTemp * 20 / 100).toFixed(2) + "\n      windingTemp: 20  - " + (windingTemp * 20 / 100).toFixed(2) + "\n      pf: 10  - " + (pf * 10 / 100).toFixed(2) + "\n      humidity: 5  -  " + (humidity * 5 / 100).toFixed(2) + "\n      load: 10  -  " + (loadValue * 10 / 100).toFixed(2) + "\n      harmonics: 0  -  " + (harmonicsvalue * 0 / 100).toFixed(2) + "\n      age: 5  - " + (age * 5 / 100).toFixed(2) + "\n      currentUnbalance: 5  - " + (iUnbalanceValue * 5 / 100).toFixed(2) + "\n      voltageUnbalance: 5  -  " + (vUnbalanceValue * 5 / 100).toFixed(2) + "\n      repaired: 5  -  " + (repaired * 5 / 100).toFixed(2) + "\n      Total_HealthIndex = " + healtIndexPercentage;
                _this.healthIndexObject.updateOptions({
                    series: [
                        Number(healtIndexPercentage)
                    ],
                    tooltip: {
                        enabled: true,
                        custom: function (_a) {
                            var series = _a.series, seriesIndex = _a.seriesIndex, dataPointIndex = _a.dataPointIndex, w = _a.w;
                            return "\n            <div style=\"white-space: normal; word-wrap: break-word; max-width: 200px;\" >\n              " + logString + "\n            </div>\n          ";
                        },
                    },
                });
            }
        };
    };
    DigitaltwinComponent.prototype.getRenewalData = function () {
        var _this = this;
        this._dashboardService.getRenewalDate(this.currentUserData.userid).subscribe(function (response) {
            if (response.result.length > 0) {
                if (response.result[0].RenewalDays >= 365 || response.result[0].dashboardaccess == 0) {
                    var domObject = document.getElementById("denyDashboardAccess");
                    domObject.style.opacity = '0.0';
                    var dialogRef = _this.matDialog.open(RenewalWindowComponent, {
                        autoFocus: false,
                        height: '85%', width: '50%', data: { data: response.result }, disableClose: true, panelClass: 'custom-dialog-container'
                    });
                    dialogRef.afterClosed().subscribe(function (response) {
                    });
                }
            }
        });
    };
    DigitaltwinComponent.prototype.getTranformerId = function (payloadtogetTransformer) {
        var _this = this;
        var userData = JSON.parse(localStorage.getItem('userData'));
        this.globalService.getfilteredTransformers(payloadtogetTransformer, localStorage.getItem('userData')).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filteredResult, queryId_1, i;
            return tslib_1.__generator(this, function (_a) {
                console.log("Response for id", response);
                if (response && response.code === '1' && response.result.length > 0) {
                    filteredResult = response.result;
                    if (userData.roleid != 1) {
                        filteredResult = response.result.filter(function (a) { return a.amc_status && a.amc_status.toLowerCase() === "active"; });
                        console.log("Filtered Result", filteredResult.length);
                        if (filteredResult.length == 0) {
                            this.router.navigate(['/dashboard']);
                        }
                    }
                    this.route.queryParams
                        .subscribe(function (params) {
                        queryId_1 = params.transformerId;
                    });
                    if (queryId_1 != undefined) {
                        for (i = 0; i < filteredResult.length; i++) {
                            if (filteredResult[i].transformerid == queryId_1) {
                                this.selectedTransformer = filteredResult[i];
                            }
                        }
                    }
                    else {
                        this.selectedTransformer = filteredResult[0];
                    }
                    this.transformerSelection(this.selectedTransformer);
                    this.transformerList = filteredResult.map(function (a) {
                        a.transformerDetail = a.transformerid + "[" + a.sitename + "]";
                        return a;
                    });
                    console.log("alltransformerid", this.transformerList);
                }
                return [2 /*return*/];
            });
        }); });
    };
    DigitaltwinComponent.prototype.transformerSelection = function (selectedTransformer) {
        var _this = this;
        this.selectedTransformer = selectedTransformer;
        console.log("daasaasasd++++++++++++", selectedTransformer.deviceId);
        if (selectedTransformer.deviceId == "abc####") {
            this.connectToWebSocket();
        }
        else {
            if (this.socket && this.socket.readyState === WebSocket.OPEN) {
                this.socket.close();
            }
            if (this.client && this.client.isConnected()) {
                console.log("Condition not met, disconnecting MQTT...");
                this.client.disconnect();
                this.client = null; // Reset client reference
                console.log("Disconnected from MQTT Broker");
            }
        }
        this._dashboardService.getRelativePressure({ transformerid: selectedTransformer.transformerid }).subscribe(function (response) {
            console.log("weather Data", response);
            if (response.status) {
                _this.weatherData = response.data;
            }
        });
        var currentDate = moment(moment().format('YYYY-MM-DD HH:mm:ss'));
        var manufactureYear = moment(moment(this.selectedTransformer.manufacturingdate).format('YYYY-MM-DD'));
        selectedTransformer.age = currentDate.diff(manufactureYear, 'years');
        this._dashboardService.getTransformerLatestData({ deviceid: selectedTransformer.deviceId }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (response.result.length > 0) {
                    console.log("-----------------------", response.result);
                    if (response.result[0].readings) {
                        this.transformerData = response.result[0];
                        this.meterData(response.result[0]);
                        this.hotSpotCalculation(response.result[0]);
                    }
                    this.jsonReadings = JSON.parse(this.transformerData.readings);
                    if (this.jsonReadings.hasOwnProperty("R_Power_Factor_2")) {
                        this.isTwoMeter = true;
                    }
                    else {
                        this.isTwoMeter = false;
                    }
                    this.getTransformerHealthIndex(selectedTransformer);
                    this.getParameterConfig(selectedTransformer);
                    this.getTransformerActiveAlert(selectedTransformer);
                    this.AIRequest = this.transformerData;
                    this.updateData();
                    //await delete AIRequest.readings;
                    console.log("JSON Readings", this.jsonReadings);
                    console.log("dara ", this.jsonReadings);
                }
                return [2 /*return*/];
            });
        }); });
    };
    DigitaltwinComponent.prototype.updateData = function () {
        if (this.transformerData.Oil_Temperature < 0) {
            this.transformerData.Oil_Temperature = 0;
        }
        if (this.transformerData.Winding_Temperature < 0) {
            this.transformerData.Winding_Temperature = 0;
        }
        this.temperatureHeight = this.calculateTemperatureHeightwind(this.transformerData.Winding_Temperature);
        this.temperatureHeightoil = this.calculateTemperatureHeight_oil(this.transformerData.Oil_Temperature);
        var currentDate = moment(moment().format('YYYY-MM-DD HH:mm:ss'));
        var checkIsOffline = moment(moment(this.transformerData.DATE).format('YYYY-MM-DD HH:mm:ss'));
        var duration = moment.duration(currentDate.diff(checkIsOffline));
        var minutes = duration.minutes();
        if (minutes > this.selectedTransformer.heartBeat) {
            this.batteryStatusImgUrl = "../../../assets/images/lowbattery.png";
        }
        else {
            this.batteryStatusImgUrl = "../../../assets/images/fullbattery.png";
        }
        if (this.jsonReadings.Avg_Power_Factor == '000') {
            this.statusImagePath = "../../../assets/images/black_trafo.png";
        }
        else if (minutes > this.selectedTransformer.heartBeat) {
            this.statusImagePath = "../../../assets/images/black_trafo.png";
        }
        else {
            this.statusImagePath = "../../../assets/images/green_transformer.png";
        }
        if (this.jsonReadings.hasOwnProperty("Lug_Temp_R")) {
            this.lugTempFlag = true;
        }
        var oilLevelIndicator = '';
        var oilLevelValues = 0;
        if (this.transformerData.Oil_Level == 4) {
            oilLevelValues = 20;
            oilLevelIndicator = "LOW";
        }
        else if (this.transformerData.Oil_Level == 5) {
            oilLevelValues = 70;
            oilLevelIndicator = "MEDIUM";
        }
        else if (this.transformerData.Oil_Level == 6) {
            oilLevelValues = 80;
            oilLevelIndicator = "HIGH";
        }
        else {
            oilLevelIndicator = this.transformerData.Oil_Level + '%';
            oilLevelValues = Number(this.transformerData.Oil_Level);
        }
        this.UpdateOilLevelGraph(oilLevelValues, oilLevelIndicator);
        var element1 = document.querySelector("#TapoilLevel");
        if (this.jsonReadings.hasOwnProperty("Oil_Level_OLTC")) {
            if (element1) {
                element1.style.opacity = '1';
            }
            var tapoilLevelIndicator = '';
            var tapoilLevelValues = 0;
            if (this.jsonReadings.Oil_Level_OLTC == "Low") {
                tapoilLevelValues = 20;
                tapoilLevelIndicator = "LOW";
            }
            else if (this.jsonReadings.Oil_Level_OLTC == "Medium") {
                tapoilLevelValues = 70;
                tapoilLevelIndicator = "MEDIUM";
            }
            else if (this.jsonReadings.Oil_Level_OLTC == "High") {
                tapoilLevelValues = 80;
                tapoilLevelIndicator = "HIGH";
            }
            else {
                tapoilLevelIndicator = this.jsonReadings.Oil_Level + '%';
                tapoilLevelValues = Number(this.jsonReadings.Oil_Level);
            }
            this.tapUpdateOilLevelGraph(tapoilLevelValues, tapoilLevelIndicator);
        }
        else {
            if (element1) {
                element1.style.opacity = '0.4';
            }
        }
        this.load = (((Number(this.jsonReadings.L1) + Number(this.jsonReadings.L2) + Number(this.jsonReadings.L3)) / 3) / Number(this.selectedTransformer.ratedLoad) * 100);
        if (this.load == "NaN") {
            this.load = 0;
        }
        this.AIRequest.age = this.selectedTransformer.age;
        this.AIRequest.kvarating = this.selectedTransformer.kvarating;
        this.AIRequest.ratedLoad = this.selectedTransformer.ratedLoad;
        this.AIRequest.load = this.load;
        this.AIRequest.Oil_Level = (this.AIRequest.Oil_Level === 4) ? "LOW" : (this.AIRequest.Oil_Level === 5 ? "MEDIUM" : "NA");
        this.AIRequestData = tslib_1.__assign({}, this.AIRequest, this.jsonReadings);
        this.updateLoadGraph(this.load.toFixed(0));
        if (this.jsonReadings.hasOwnProperty("Network")) {
            this.networkFlag = true;
            this.NetworkValue = this.jsonReadings.Network;
            if (this.NetworkValue >= 2 && this.NetworkValue <= 9) {
                this.signalStrength = 1;
            }
            else if (this.NetworkValue >= 10 && this.NetworkValue <= 14) {
                this.signalStrength = 2;
            }
            else if (this.NetworkValue >= 15 && this.NetworkValue <= 19) {
                this.signalStrength = 3;
            }
            else if (this.NetworkValue >= 20 && this.NetworkValue <= 25) {
                this.signalStrength = 4;
            }
            else if (this.NetworkValue >= 26 && this.NetworkValue <= 31) {
                this.signalStrength = 5;
            }
        }
    };
    DigitaltwinComponent.prototype.getParameterConfig = function (selectedTransformer) {
        var _this = this;
        this._dashboardService.parameterConfig(selectedTransformer.transformerid).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var opacity, element, opacity1, element1, ratedLoad, load, LoadPercentage, gradient;
            return tslib_1.__generator(this, function (_a) {
                if (response.result.length > 0) {
                    this.parameterConfig = response.result[0];
                    opacity = this.parameterConfig.l1 == 1 ? '1' : '0.4';
                    element = document.querySelector("#isLoadOn");
                    if (element) {
                        element.style.opacity = opacity;
                    }
                    opacity1 = this.parameterConfig.oillevel == 1 ? '1' : '0.4';
                    element1 = document.querySelector("#isOilLevelOn");
                    if (element1) {
                        element1.style.opacity = opacity1;
                    }
                    if (this.transformerData) {
                        this.voltageparameter = this.parameterConfig.ryVoltage == "1";
                        this.currentparameter = this.parameterConfig.l1 == "1";
                        if (this.parameterConfig.lugtempr == 1) {
                            this.Lug_Temp_R = Number(this.jsonReadings.Lug_Temp_R).toFixed(2);
                            this.Lug_Temp_Y = Number(this.jsonReadings.Lug_Temp_Y).toFixed(2);
                            this.Lug_Temp_B = Number(this.jsonReadings.Lug_Temp_B).toFixed(2);
                        }
                        if (this.parameterConfig.windingtemperaturebycal == '1') {
                            ratedLoad = 0;
                            if (!isNaN(this.load)) {
                                ratedLoad = this.load;
                            }
                            load = Number(((Number(this.jsonReadings.L1) +
                                Number(this.jsonReadings.L2) +
                                Number(this.jsonReadings.L3)) / 3).toFixed(2));
                            LoadPercentage = Number(((load / Number(this.selectedTransformer.ratedLoad)) * 100).toFixed(2));
                            gradient = Number(this.selectedTransformer.kwhreading);
                            this.transformerData.Winding_Temperature = Number(Number(this.transformerData.Oil_Temperature) + ((gradient * LoadPercentage) / 100)).toFixed(2);
                            console.log("what is calculated value", this.transformerData.Winding_Temperature);
                            if (this.transformerData.Winding_Temperature == "NaN") {
                                this.transformerData.Winding_Temperature = 0;
                            }
                            this.temperatureHeight = this.calculateTemperatureHeightwind(this.transformerData.Winding_Temperature);
                            //this.AIRequestData.Winding_Temperature = this.transformerData.Winding_Temperature;
                        }
                    }
                    console.log("dasa", this.parameterConfig);
                }
                return [2 /*return*/];
            });
        }); });
    };
    DigitaltwinComponent.prototype.calculateTemperatureHeight_oil = function (temp) {
        var maxHeight = 38;
        var minHeight = 0;
        var minTemp = 0;
        var maxTemp = 60;
        var clampedTemp = Math.min(Math.max(temp, minTemp), maxTemp);
        var heightPercentage = (clampedTemp - minTemp) / (maxTemp - minTemp);
        var height = minHeight + heightPercentage * (maxHeight - minHeight);
        return height + "px";
    };
    DigitaltwinComponent.prototype.calculateTemperatureHeightwind = function (temp) {
        var maxHeight = 38;
        var minHeight = 0;
        var minTemp = 0;
        var maxTemp = 60;
        var clampedTemp = Math.min(Math.max(temp, minTemp), maxTemp);
        var heightPercentage = (clampedTemp - minTemp) / (maxTemp - minTemp);
        var height = minHeight + heightPercentage * (maxHeight - minHeight);
        return height + "px";
    };
    DigitaltwinComponent.prototype.TapoilLevel = function (value) {
        var options = {
            series: [value],
            chart: {
                height: '100%',
                width: '100%',
                type: 'radialBar',
                offsetY: 0
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '50%',
                            color: '#964B00',
                            offsetY: '-5%',
                            fontFamily: 'Orbitron, sans-serif'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '60%',
                            color: 'black',
                            formatter: function (val, opts) {
                                return 'No Data';
                            },
                            fontFamily: 'Orbitron, sans-serif'
                        }
                    }
                }
            },
            colors: ['blue'],
            stroke: {
                dashArray: 0
            },
            labels: ['OLTC Oil Level'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.tapoilLevelGraphObject = new ApexCharts(document.querySelector("#TapoilLevel"), options);
        this.tapoilLevelGraphObject.render();
    };
    DigitaltwinComponent.prototype.oilLevel = function (value) {
        var options = {
            series: [value],
            chart: {
                height: '100%',
                width: '100%',
                type: 'radialBar',
                offsetY: 0
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '100%',
                            color: '#8E4701',
                            offsetY: '-5%',
                            fontFamily: 'Orbitron, sans-serif'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '100%',
                            color: 'black',
                            formatter: function (val, opts) {
                                return 'No Data';
                            },
                            fontFamily: 'Orbitron, sans-serif'
                        }
                    }
                }
            },
            colors: ['blue'],
            stroke: {
                dashArray: 0
            },
            labels: ['Oil Level'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.oilLevelGraphObject = new ApexCharts(document.querySelector("#oilLevel"), options);
        this.oilLevelGraphObject.render();
    };
    DigitaltwinComponent.prototype.loadGraph = function () {
        var options = {
            series: [0],
            chart: {
                type: 'radialBar',
                height: "100%",
            },
            plotOptions: {
                radialBar: {
                    startAngle: -120,
                    endAngle: 240,
                    hollow: {
                        margin: 0,
                        size: '60%',
                        background: '#2E3B4E',
                    },
                    track: {
                        background: '#EDEDED',
                        strokeWidth: '80%',
                    },
                    dataLabels: {
                        name: {
                            fontFamily: 'Orbitron, sans-serif'
                        },
                        value: {
                            fontSize: '2.5vh',
                            fontWeight: 'bold',
                            color: '#FFFFFF',
                            formatter: function (val) {
                                return val + "%";
                            },
                            fontFamily: 'Orbitron, sans-serif'
                        }
                    }
                }
            },
            stroke: {
                lineCap: 'round'
            },
            colors: ['#F57C00'],
            labels: ['Load']
        };
        this.loadChart = new ApexCharts(document.querySelector("#load"), options);
        this.loadChart.render();
    };
    DigitaltwinComponent.prototype.UpdateOilLevelGraph = function (value, label) {
        var color = '#008000';
        if (value < 25) {
            color = '#FF0000';
        }
        else if (value > 70) {
            color = '#FFA500';
        }
        this.oilLevelGraphObject.updateOptions({
            series: [
                value
            ],
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        value: {
                            formatter: function (val, opts) {
                                return label;
                            },
                            color: '#FFFFFF'
                        }
                    }
                }
            },
            colors: [color]
        });
    };
    DigitaltwinComponent.prototype.tapUpdateOilLevelGraph = function (value, label) {
        var color = '#008000';
        if (value < 25) {
            color = '#FF0000';
        }
        else if (value > 70) {
            color = '#FFA500';
        }
        this.tapoilLevelGraphObject.updateOptions({
            series: [
                value
            ],
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        value: {
                            formatter: function (val, opts) {
                                return label;
                            },
                            color: '#FFFFFF'
                        }
                    }
                }
            },
            colors: [color]
        });
    };
    DigitaltwinComponent.prototype.updateLoadGraph = function (value) {
        if (value == "NaN") {
            value = 0;
        }
        var color = '#008000';
        if (value > 80) {
            color = '#FF0000';
        }
        this.loadChart.updateOptions({
            series: [
                value
            ],
            colors: [color]
        });
    };
    DigitaltwinComponent.prototype.hotSpotCalculation = function (transformerData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var oilTempRise, hotspotGradient, ambientTemp, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        oilTempRise = Number(transformerData.Oil_Temperature) * (1.2) * 0.9;
                        hotspotGradient = 15 * (1.2) * 0.9;
                        ambientTemp = Number(transformerData.Ambient_Temperature);
                        this.hotSpotCalculationValue = Number(ambientTemp + oilTempRise + hotspotGradient).toFixed(2);
                        console.log("temp Hotspot calc/[[[[[", this.hotSpotCalculationValue);
                        _a = this;
                        return [4 /*yield*/, this.calculateTemperatureHeight_Hotspot(this.hotSpotCalculationValue)];
                    case 1:
                        _a.temperatureHeightHotspot = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DigitaltwinComponent.prototype.calculateTemperatureHeight_Hotspot = function (temp) {
        var maxHeight = 38;
        var minHeight = 0;
        var minTemp = 0;
        var maxTemp = 60;
        var clampedTemp = Math.min(Math.max(temp, minTemp), maxTemp);
        var heightPercentage = (clampedTemp - minTemp) / (maxTemp - minTemp);
        var height = minHeight + heightPercentage * (maxHeight - minHeight);
        return height + "px";
    };
    DigitaltwinComponent.prototype.getTransformerActiveAlert = function (selectedTransformer) {
        var _this = this;
        this.alertsData = [];
        var alerts = [];
        this._dashboardService.getTransformerActiveAlert({ "transformerid": selectedTransformer.transformerid, "frequency": selectedTransformer.heartBeat }).subscribe(function (response) {
            if (response.result.length > 0) {
                _this.statusImagePath = "../../../assets/images/red_transformer.png";
                response.result.slice().reverse().forEach(function (value) {
                    value.parametername = value.parametername.replace(/^ap/, '') + ", ";
                    if (!alerts.includes(value.parametername)) {
                        alerts.push(value.parametername);
                        _this.alertsData.push(value);
                    }
                });
                console.log("alerts", _this.alertsData);
            }
        });
    };
    DigitaltwinComponent.prototype.healthIndexData = function () {
        var options = {
            series: [10],
            chart: {
                height: '100%',
                width: '100%',
                type: 'radialBar',
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 225,
                    hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#2a5c9f',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                    },
                    track: {
                        background: '#5ca1fe',
                        strokeWidth: '67%',
                        margin: 0,
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                    },
                    dataLabels: {
                        show: true,
                        name: {
                            offsetY: 0,
                            show: true,
                            color: '#fff',
                            fontSize: '1.8vh',
                            fontFamily: 'Orbitron, sans-serif'
                        },
                        value: {
                            formatter: function (val) {
                                return val + "%";
                            },
                            color: '#fff',
                            fontSize: '2.9vh',
                            show: true,
                            fontFamily: 'Orbitron, sans-serif'
                        }
                    }
                }
            },
            fill: {
                colors: ["#007506"],
            },
            stroke: {
                lineCap: 'round'
            },
            labels: ['Health Index'],
        };
        this.healthIndexObject = new ApexCharts(document.querySelector("#healthIndex"), options);
        this.healthIndexObject.render();
    };
    DigitaltwinComponent.prototype.meterData = function (data) {
        console.log("slectedsss", this.selectedTransformer);
        if (data.readings) {
            try {
                var parsedReadings = JSON.parse(data.readings);
                data = tslib_1.__assign({}, data, parsedReadings);
                delete data.readings;
            }
            catch (error) {
                console.error("Error parsing readings:", error);
            }
        }
        this.kWh = data.System_kwh !== undefined && data.System_kwh !== null ? data.System_kwh : 0;
        this.kvArh = data.System_kvArh !== undefined && data.System_kvArh !== null ? data.System_kvArh : 0;
        this.avgPF = data.Avg_Power_Factor !== undefined && data.Avg_Power_Factor !== null ? Math.abs(data.Avg_Power_Factor) : 0;
        this.kVAh = data.System_Kvah != undefined && data.System_Kvah != null ? data.System_Kvah : 0;
        this.voltage_l1 = data.RY_Voltage !== undefined && data.RY_Voltage !== null ? data.RY_Voltage : 0;
        this.voltage_l2 = data.YB_Voltage !== undefined && data.YB_Voltage !== null ? data.YB_Voltage : 0;
        this.voltage_l3 = data.BR_Voltage !== undefined && data.BR_Voltage !== null ? data.BR_Voltage : 0;
        this.current_l1 = data.L1 !== undefined && data.L1 !== null ? data.L1 : 0;
        this.current_l2 = data.L2 !== undefined && data.L2 !== null ? data.L2 : 0;
        this.current_l3 = data.L3 !== undefined && data.L3 !== null ? data.L3 : 0;
        this.activePower = data['3 Phase Active Power'] !== undefined && data['3 Phase Active Power'] !== null ? data['3 Phase Active Power'] : 0;
        this.lastUpdateDate = data.latestDATE !== undefined && data.latestDATE !== null ? data.latestDATE : '';
    };
    DigitaltwinComponent.prototype.showNext = function () {
        if (this.showInfo === 'first') {
            this.showInfo = 'second';
        }
        else if (this.showInfo === 'second') {
            this.showInfo = 'third';
        }
        else if (this.showInfo === 'third') {
            this.showInfo = 'first'; // Circular navigation
        }
    };
    DigitaltwinComponent.prototype.resetkwhreset = function () {
        this.showInfo = 'first';
    };
    DigitaltwinComponent.prototype.showPrev = function () {
        if (this.showInfo === 'first') {
            this.showInfo = 'third'; // Circular navigation
        }
        else if (this.showInfo === 'third') {
            this.showInfo = 'second';
        }
        else if (this.showInfo === 'second') {
            this.showInfo = 'first';
        }
    };
    DigitaltwinComponent.prototype.getTransformerHealthIndex = function (selectedTransformer) {
        var _this = this;
        this._dashboardService.getTransformerHealthIndex(selectedTransformer.transformerid).subscribe(function (response) {
            console.log("Health Index Response", response);
            if (response.data.length > 0) {
                var healthTooltipHtml_1 = _this.formatHealthTooltip(response.data[0].alldata);
                _this.healthIndexObject.updateOptions({
                    series: [
                        response.data[0].percentage
                    ],
                    tooltip: {
                        enabled: true,
                        custom: function () {
                            return healthTooltipHtml_1;
                        },
                    },
                });
                console.log("response.data[0].allData", response.data[0]);
                _this.dataforHealthIndex = response.data[0].alldata;
            }
        });
    };
    DigitaltwinComponent.prototype.toggleChatBox = function () {
        this.isChatOpen = !this.isChatOpen;
        //this.messages.push({ message: "BOLA!, How can I assist you Today?", sender: 'user' });
    };
    DigitaltwinComponent.prototype.sendMessage = function () {
        var _this = this;
        if (this.userMessage.trim()) {
            this.userMessage;
            this.messages.push({ message: this.userMessage, sender: 'user' });
            this.isTyping = true;
            console.log("message from user", this.userMessage);
            setTimeout(function () {
                _this.messages.push({ message: '', sender: 'ai' });
                var selfRelatedKeywords = [
                    "who are you",
                    "tell me about yourself",
                    "what is your name",
                    "who created you",
                    "about yourself",
                    "who developed bola",
                    "who develop bola",
                    "who devloped bola",
                    "who devlop bola"
                ];
                var whatBola = [
                    "what is bola",
                    "tell me about bola"
                ];
                var customerSupportKeywords = [
                    "customer support",
                    "contact support",
                    "help desk",
                    "support number",
                    "customer care",
                    "technical support",
                    "report issue",
                    "get help",
                    "support team",
                    "contact customer service"
                ];
                var lowercasedInput = _this.userMessage.toLowerCase();
                var isCustomerSupportRelated = customerSupportKeywords.some(function (keyword) { return lowercasedInput.includes(keyword); });
                var isBOLARelated = whatBola.some(function (keyword) { return lowercasedInput.includes(keyword); });
                var isSelfRelated = selfRelatedKeywords.some(function (keyword) { return lowercasedInput.includes(keyword); });
                if (isCustomerSupportRelated) {
                    _this.userMessage = '';
                    _this.typeAiResponse("<p>BOLA Support Team</p><ul><li><strong>Sales Support:</strong> Ganesh Patil - <a href=\"tel:+917020971892\">+91 70209 71892</a></li> <li><strong>Hardware Support:</strong> Lovekush Sharma - <a href=\"tel:+919079950438\">+91 90799 50438</a></li> <li><strong>Software Support:</strong> Rakesh Bhamare - <a href=\"tel:+919657962379\">+91 96579 62379</a></li> <li><strong>Customer Support:</strong> Yogesh Kadam - <a href=\"tel:+918390332647\">+91 83903 32647</a></li></ul> <p style=\"text-align:center\">Mail:  chitra.rothe@kryfs.com</p> <p>We are here to assist you with any queries or issues. Feel free to reach out!</p> ");
                }
                else if (isBOLARelated) {
                    _this.userMessage = '';
                    _this.typeAiResponse("To prevent transformer failures and increase the life and reliability of transformers, KRYFS Technologies has developed a low cost solution, named BOLA (Better Operations and Life by Analytics) which is an IOT remote monitoring solution for Distribution, Power Transformers, Electrical machines and Energy Meters. BOLA will monitor the vital parameters of a transformer (Electrical and physical) in real time from any location on our proprietary dashboard on your mobile and computer. The solution diagnoses & sends alerts/notifications on SMS & email whenever there is any abnormality sensed and hence allows to take preventive action before the actual failure happens. It can be retrofitted on any old or new Transformer. The risk of failure is eliminated using alarm rules and detections of deviations for the reference values of threshold (E.g. Oil and winding temperature, Transformer loading, and Oil level)");
                }
                else if (isSelfRelated) {
                    _this.userMessage = '';
                    _this.typeAiResponse("I am BOLA, an AI model designed and developed by Kryfs Technologies Pvt. Ltd. To prevent transformer failures and enhance their lifespan and reliability, KRYFS Technologies has introduced a cost-effective solution named BOLA (Better Operations and Life by Analytics). BOLA is an IoT-based remote monitoring system designed for Distribution and Power Transformers, Electrical Machines, and Energy Meters.");
                }
                else {
                    _this._dashboardService.aiModule({ "message": _this.userMessage + JSON.stringify(_this.AIRequestData) }).subscribe(function (response) {
                        _this.userMessage = '';
                        _this.typeAiResponse(response.data.content);
                    });
                }
            }, this.typingDelay);
        }
    };
    DigitaltwinComponent.prototype.typeAiResponse = function (response) {
        var _this = this;
        if (this.messages.length === 0)
            return; // Prevent errors if messages array is empty
        var index = 0;
        var aiMessage = this.messages[this.messages.length - 1];
        var typingInterval = setInterval(function () {
            if (index < response.length) {
                aiMessage.message += response[index];
                index++;
            }
            else {
                clearInterval(typingInterval);
                _this.isTyping = false; // Ensure typing status updates correctly
            }
            setTimeout(function () { return _this.scrollToBottom(); }, 100);
        }, 5);
        this.isTyping = true; // Set isTyping to true when typing starts
        console.log("data", aiMessage);
    };
    DigitaltwinComponent.prototype.scrollToBottom = function () {
        if (this.chatWindow) {
            this.chatWindow.nativeElement.scrollTop = this.chatWindow.nativeElement.scrollHeight;
        }
    };
    DigitaltwinComponent.prototype.initializeMQTT = function () {
        var _this = this;
        try {
            var CLIENT_ID = 'angular_client_' + Math.random().toString(16).substring(2, 8);
            var MQTT_SERVER = "tndmoiot.tatapower.com";
            var MQTT_TOPIC_1 = "BOLA_KRYFS";
            var MQTT_PORT = 443; // Use 8083 if your broker is configured for WebSockets
            // Use secure WebSocket (wss://) for HTTPS environments
            this.client = new Paho.MQTT.Client("wss://" + MQTT_SERVER + ":" + MQTT_PORT + "/mqtt", CLIENT_ID);
            // Handle connection loss
            this.client.onConnectionLost = function (responseObject) {
                console.error("Connection lost:", responseObject.errorMessage || "Unknown reason");
            };
            // Handle incoming messages
            this.client.onMessageArrived = function (message) {
                try {
                }
                catch (error) {
                    console.error("Error parsing message:", error);
                }
            };
            // Connection options for subscribing
            var options = {
                onSuccess: function () {
                    console.log("Connected to MQTT Broker, subscribing to topic...");
                    _this.client.subscribe(MQTT_TOPIC_1, {
                        onSuccess: function () { return console.log("Successfully subscribed to:", MQTT_TOPIC_1); },
                        onFailure: function (error) { return console.error("Subscription failed:", error.errorMessage); },
                    });
                },
                onFailure: function (error) {
                    console.error("Failed to connect:", error.errorMessage || "Unknown error");
                }
            };
            // Connect to the broker
            this.client.connect(options);
        }
        catch (error) {
            console.error("Error initializing MQTT client:", error);
        }
    };
    DigitaltwinComponent.prototype.toggleMQTTConnection = function (data) {
    };
    DigitaltwinComponent.prototype.open_individual = function (TransformerID) {
        var dialogRef = this.matDialog.open(IndividualDashboardComponent, {
            autoFocus: true,
            height: '90%', width: '95%', data: TransformerID
        });
    };
    DigitaltwinComponent.prototype.openReport = function (TransformerID) {
        var dialogRef = this.matDialog.open(ReportComponent, {
            autoFocus: true,
            height: '90%', width: '95%', data: TransformerID
        });
    };
    DigitaltwinComponent.prototype.alertReport = function (TransformerID) {
        var dialogRef = this.matDialog.open(AlertReportComponent, {
            autoFocus: true,
            height: '90%', width: '95%', data: TransformerID
        });
    };
    DigitaltwinComponent.prototype.AIInsights = function (data) {
        var parseData = JSON.parse(this.transformerData.readings);
        delete this.transformerData.readings;
        var sensorData = tslib_1.__assign({}, this.transformerData, parseData);
        delete sensorData.DATE;
        delete sensorData.Deviceid;
        if (sensorData.Oil_Level === "LOW") {
            sensorData.Oil_Level = 4;
        }
        else if (sensorData.Oil_Level === "MEDIUM") {
            sensorData.Oil_Level = 5;
        }
        // Current Unbalance
        var avgCurrent = (Number(sensorData.L1) +
            Number(sensorData.L2) +
            Number(sensorData.L3)) / 3;
        var currentDeviation = Math.max(Math.abs(Number(sensorData.L1) - avgCurrent), Math.abs(Number(sensorData.L2) - avgCurrent), Math.abs(Number(sensorData.L3) - avgCurrent));
        sensorData.currentUnbalance =
            avgCurrent > 0
                ? Number(((currentDeviation * 100) / avgCurrent).toFixed(2))
                : 0;
        // Voltage Unbalance
        var avgVoltage = (Number(sensorData.RY_Voltage) +
            Number(sensorData.YB_Voltage) +
            Number(sensorData.BR_Voltage)) / 3;
        var voltageDeviation = Math.max(Math.abs(Number(sensorData.RY_Voltage) - avgVoltage), Math.abs(Number(sensorData.YB_Voltage) - avgVoltage), Math.abs(Number(sensorData.BR_Voltage) - avgVoltage));
        sensorData.voltageUnbalance =
            avgVoltage > 0
                ? Number(((voltageDeviation * 100) / avgVoltage).toFixed(2))
                : 0;
        // Harmonics
        sensorData.harmonics =
            ((Number(sensorData.VB_THD || 0) +
                Number(sensorData.VR_THD || 0) +
                Number(sensorData.VY_THD || 0)) /
                3 *
                100).toFixed(2);
        var tranformerData = { transformerId: data.transformerid,
            Deviceid: data.deviceId,
            transformerType: "Distribution",
            ratingKVA: data.kvarating,
            voltageClass: "11",
            "coolingMethod": "ONAN",
            "frequencyRating": 50,
            "manufacturer": "Voltamp",
            "vectorGroup": "Dyn11"
        };
        var requestData = { transformer: tranformerData, sensorData: sensorData };
        console.log("data", requestData);
        var dialogRef = this.matDialog.open(AiModelComponent, {
            autoFocus: true,
            height: '90%', width: '95%', data: requestData
        });
    };
    DigitaltwinComponent.prototype.lastfive = function () {
    };
    DigitaltwinComponent.prototype.openLiveGraph = function () {
        this.selectedTransformer.deviceId;
        var dialogRef = this.matDialog.open(RealTimeGraphsComponent, {
            autoFocus: true,
            height: '90%', width: '95%', data: this.selectedTransformer.deviceId
        });
    };
    DigitaltwinComponent.prototype.openLiveTable = function () {
        this.selectedTransformer.deviceId;
        var dialogRef = this.matDialog.open(LiveTableComponent, {
            autoFocus: true,
            height: '90%', width: '95%', data: this.selectedTransformer.deviceId
        });
    };
    DigitaltwinComponent.prototype.formatHealthTooltip = function (raw) {
        if (!raw)
            return '';
        var labelMap = {
            oilLevel: 'Oil Level',
            oilTemp: 'Oil Temp',
            windingTemp: 'Winding Temp',
            pf: 'Power Factor',
            humidity: 'Humidity',
            load: 'Load',
            harmonics: 'Harmonics',
            age: 'Age',
            currentUnbalance: 'Current Unbalance',
            voltageUnbalance: 'Voltage Unbalance',
            repaired: 'Repaired'
        };
        var rowRegex = /([A-Za-z_]+)\s*:\s*([\d.]+)\s*-\s*([\d.]+)/g;
        var totalRegex = /Total_HealthIndex\s*=\s*([\d.]+)/;
        var rowsHtml = '';
        var match;
        while ((match = rowRegex.exec(raw)) !== null) {
            var key = match[1];
            var weight = match[2];
            var value = match[3];
            var label = labelMap[key] || key;
            rowsHtml += "\n      <div class=\"ht-row\">\n        <span class=\"ht-label\">" + label + "</span>\n        <span class=\"ht-weight\">" + weight + "</span>\n        <span class=\"ht-value\">" + value + "</span>\n      </div>";
        }
        var totalMatch = raw.match(totalRegex);
        var total = totalMatch ? totalMatch[1] : '';
        return "\n    <div class=\"health-tooltip\">\n      <div class=\"ht-header\">\n        <span class=\"ht-label\">Parameter</span>\n        <span class=\"ht-weight\">Wt</span>\n        <span class=\"ht-value\">Score</span>\n      </div>\n      " + rowsHtml + "\n      <div class=\"ht-total\">Total Health Index: <b>" + total + "%</b></div>\n    </div>\n  ";
    };
    return DigitaltwinComponent;
}());
export { DigitaltwinComponent };
